import { useSelector } from "react-redux";

import messages from "../../../../../../../assets/locale/messages";
import ViewUploadedFile from "../../../../../../../components/Upload/FileUpload/ViewUploadedFile";
import { OFF_PLATFORM_VERIFICATION_DOCUMENTS_TYPES } from "../../../../../../../utils/Constants";

const DocumentsSection = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { businessVerification } = messages[lang];

  const requestDetails = useSelector(
    (state) =>
      state.businessVerification.offPlatformVerificationRequestDetails
  );

  return (
    <div className="view-uploaded-documents">
      <div className="pt-4">
        <p className="fsize-13 title-color">
          {
            businessVerification.requestDetails.offplatformRequest
              .reviewDocs.uploadedDocs
          }
        </p>
        <div className="row">
          {requestDetails?.CompanyDataDTO?.CompanyDocuments?.map(
            ({
              Id,
              DocumentName,
              OriginalDocumentName,
              DocumentTypeId
            }) => (
              <div
                key={`document-${Id}`}
                className="col-12 col-xl-6 mb-3">
                <ViewUploadedFile
                  file={DocumentName}
                  type={
                    DocumentTypeId ===
                    OFF_PLATFORM_VERIFICATION_DOCUMENTS_TYPES.pdf
                      ? "pdf"
                      : "image"
                  }
                  name={OriginalDocumentName}
                  viewMode
                  isFileLink
                />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentsSection;
